// extracted by mini-css-extract-plugin
module.exports = {"full-list":"LoadMore_full-list__39JuY"};